import { Component, OnInit, Output } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { TranslationService } from '@sdbn/common';
import { Subject } from 'rxjs';
import { Transport, TransportPlanningType, TransportReceiver } from '../../../../common/model/transport.model';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-timeslot-field',
  templateUrl: './timeslot-field.component.html',
  styleUrls: ['./timeslot-field.component.scss']
})
export class TimeslotFieldComponent implements OnInit, TransportReceiver {

  TransportPlanningType = TransportPlanningType;

  dt = DateTime.now();

  @Output() valueChange = new Subject<null>();

  transport: Transport;

  formGroup = new FormGroup({
    planningType: new FormControl(TransportPlanningType.DEFAULT, []),
    timeSlotDate: new FormControl(null, []),
    inAdvanceDate: new FormControl(null, [])
  });

  constructor(public translationService: TranslationService) {
  }

  ngOnInit(): void {

    this.formGroup.valueChanges.subscribe(value => {

      console.log('handling values', value, this.transport);

      this.transport.timing.planningType = value.planningType;
      this.transport.timing.timeSlotDate = TransportPlanningType.TIMEFRAME == value.timeSlotDate != null? this.formatDateStringToTimestamp(value.timeSlotDate) : null;
      this.transport.timing.inAdvanceDate = TransportPlanningType.IN_ADVANCE == value.inAdvanceDate != null? this.convertDateToTimestamp(value.inAdvanceDate) : null;
      if (this.transport.timing.planningType === TransportPlanningType.IN_ADVANCE && this.transport.timing.inAdvanceDate == null) {
        console.log('patching value in advance');
        this.formGroup.patchValue({ inAdvanceDate: new Date() });
      }
      this.valueChange.next();
    });

  }

  public setTransport(value: Transport) {
    console.log('processing transport', value);
    this.transport = value;
    this.formGroup.patchValue({
      planningType: this.transport.timing.planningType,
      timeSlotDate: this.formatTimestampToDateString(this.transport.timing.timeSlotDate),
      inAdvanceDate: this.parseDateFromTimestamp(this.transport.timing.inAdvanceDate)
    });
  }

  // später in zentralen Service verschieben
  private formatTimestampToDateString(value: string): string {
    if (value == null) {
      return null;
    }
    if (value.length < 12) {
      return null;
    }
    return value.substring(0, 4) + '-' + value.substring(4, 6) + '-' + value.substring(6, 8) + 'T' + value.substring(8, 10) + ':' + value.substring(10, 12);
  }

  private formatDateStringToTimestamp(value: string): string {
    if (value == null) {
      return null;
    }
    if (value.length < 16) {
      return null;
    }
    return value.substring(0, 4) + value.substring(5, 7) + value.substring(8, 10) + value.substring(11, 13) + value.substring(14, 16) + '00';
  }

  private convertDateToTimestamp(value: Date): string {
    if (value != null) {
      return DateTime.fromJSDate(value).toFormat("yyyyMMdd");
    }
    return null;
  }

  private parseDateFromTimestamp(value: string): Date {
    if (value != null) {
      return DateTime.fromFormat(value, "yyyyMMdd").toJSDate();
    }
    return null;
  }

}
